import {Component, computed, EventEmitter, input, output, Output} from '@angular/core';
import {Message} from 'primeng/message';
import {Tooltip} from 'primeng/tooltip';

export type MessageSeverity = 'success' | 'info' | 'warning' | 'error';

@Component({
  selector: 'app-message',
    imports: [
        Message,
        Tooltip
    ],
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss'
})
export class MessageComponent {

    severity = input<MessageSeverity>('info');
    closable = input(false);
    showIcon = input(false);
    onClose = output<any>();
    closeButtonTooltip = input<string>();

    protected primeNgSeverity = computed<'success' | 'info' | 'warn' | 'secondary' | 'contrast' | 'error'>(() => {
        switch (this.severity()) {
            case 'success': return 'success';
            case 'info': return 'info';
            case 'warning': return 'warn';
            case 'error': return 'error';
            default: return 'info';
        }
    });

}
